import $ from 'jquery'
import 'jquery-match-height'
import 'parsleyjs'
import "slick-slider"
import 'popper.js'
import 'bootstrap'
import "bootstrap-select"
import 'bootstrap-select/dist/css/bootstrap-select.min.css';

$(document).ready(function () {
    if (!$('#tx-ppu-container').length) {
        return;
    }

    var ppuContainer = $('#tx-ppu-container')
    var ppuEventKey = 'payPerUse'
    if (ppuApp == 'rent') {
        ppuEventKey = 'rent'
    }

    var ppuDataDefault = {
        app: ppuApp,
        maxSteps: 4,
        maxStepsBeforeSkip: 0,
        step: 0,
        selection: {
            1: 0, // Zweck
            2: 0, // Gebäudeart
            3: 0, // Tätigkeit
            4: 0 // ggf. genauere Tätigkeit
        },
        forCustomer: 0,
        input: {
            room: {
                dailyUsage: 0,
                daysPerMonth: 0,
                sizeY: 0,
                sizeX: 0,
                sizeZ: 0
            },
            contact: {
                id: '',
                salutation: 0,
                lastname: '',
                firstname: '',
                company: '',
                address: '',
                postal: '',
                city: '',
                country: '',
                email: '',
                phone: '',
                message: ''
            },
            customer: {
                salutation: 0,
                lastname: '',
                firstname: '',
                company: '',
                address: '',
                postal: '',
                city: '',
                country: '',
                email: '',
                phone: ''
            }
        }
    }
    var ppuData = jQuery.extend(true, {}, ppuData)

    function ppuHtmldecode(sEncodedString) {
        var parser = new DOMParser
        var dom = parser.parseFromString('<!doctype html><body>' + sEncodedString, 'text/html')
        return dom.body.textContent;
    }

    function ppuInitParsley() {
        if (!$.fn.parsley) {
            return;
        }

        ppuContainer.find('form').each(function () {
            $(this).parsley({
                namespace: 'data-parsley-',
                trigger: 'blur change',
                animate: false,
                validationMinlength: 0,
                errors: {
                    classHandler: function (elem, isRadioOrCheckbox) {
                        var el = $(elem)

                        // Move Errors into the bootstrap-select class
                        if (el.is('select') && el.hasClass('cms-selectpicker')) {
                            var newEl = el.next()
                            if (newEl.hasClass('bootstrap-select')) {
                                return newEl;
                            }

                            newEl = el.parent().find('.bootstrap-select').first()
                            if (newEl.hasClass('bootstrap-select')) {
                                return newEl;
                            }
                        }

                        // Move Checkbox errors into the label (where the text & checkbox is visually rendered)
                        if (el.is('input[type="checkbox"]')) {
                            return el.closest('label');
                        }
                        return el;
                    },
                    container: function (elem, isRadioOrCheckbox) {
                        var el = $(elem)
                        var $container

                        // Does a manual error container exist?
                        var manualContainer = el.data('parsley-container')
                        if (manualContainer) {
                            $container = $(manualContainer)
                            if ($container.length) {
                                return $container;
                            }
                        }

                        // Error messages of selectboxes need to be aftere the bootstrap-select thing
                        if (el.is('select') && el.hasClass('cms-selectpicker')) {
                            $container = el.parent().find(".parsley-container")
                            if ($container.length === 0) {
                                $container = $("<div class='parsley-container'></div>").insertAfter(el.next())
                            }
                            return $container;
                        }
                    }
                }
            }).on('field:validated', function() {
                ppuContainer.find('.tx-ppu-slider').slick('setPosition')
            })
        })

        // Boostrap Select Validation on Change
        ppuContainer.find('form .selectpicker').bind('change', function () {
            $(this).parsley().validate()
            if ($(this).hasClass('parsley-error')) {
                $(this).parent(".bootstrap-select").addClass('parsley-error')
            } else {
                $(this).parent(".bootstrap-select").removeClass('parsley-error')
            }
        })

        // Boostrap Select Validation on submit
        window.Parsley.on('form:error', function () {
            $(".selectpicker").each(function () {
                if ($(this).hasClass('parsley-error')) {
                    $(this).parent(".bootstrap-select").addClass('parsley-error')
                } else {
                    $(this).parent(".bootstrap-select").removeClass('parsley-error')
                }
            })
        })
    }

    function ppuTemplate(name) {
        return $('#tx-ppu-templates [data-template="' + name + '"]').clone()
    }

    function ppuScrollTop() {
        if ($(window).scrollTop() < ppuContainer.offset().top) {
            return;
        }

        $('html, body').animate({
            scrollTop: ppuContainer.offset().top - 55
        }, 1000)
    }

    function ppuUpdateProgress() {
        $('.tx-ppu-progressbar .tx-ppu-progress').css('width', 100 / (ppuData.maxSteps + 1) * ppuData.step + '%')
    }

    function ppuSetStep(step) {
        ppuScrollTop()
        ppuContainer.find('.tx-ppu-slider').slick('slickGoTo', step)
        window.setTimeout(function () {
            ppuContainer.find('.tx-ppu-slider').slick('slickRemove', step + 1, false)
        }, 1000)

        if (ppuData.step == 0) {
            $('.tx-ppu-navigation').removeClass('tx-ppu-visible')
            ppuContainer.find('.tx-ppu-gradient').removeClass('tx-ppu-active')

            window.setTimeout(function () {
                $('.tx-ppu-navigation').removeClass('tx-ppu-active')
                ppuUpdateProgress()
            }, 1000)
        } else {
            ppuUpdateProgress()
        }
        
        if (ppuContainer.find('.tx-ppu-slider .slick-active .tx-ppu-slide').attr('data-info')) {
            ppuContainer.find('.tx-ppu-info').addClass('tx-ppu-visible')
        } else {
            ppuContainer.find('.tx-ppu-info').removeClass('tx-ppu-visible')
        }
    }

    function ppuStart(type) {
        ppuData = jQuery.extend(true, {}, ppuDataDefault)
        ppuData.step++

        if (type == 'partner') {
            ppuData.maxSteps++
            ppuData.forCustomer = 1
        } else {
            ppuData.forCustomer = 0
        }

        if (ppuUserId) {
            ppuData.input.contact.id = ppuUserId
        }

        dataLayer.push({
            'event': ppuEventKey,
            'step': '0'
        })

        $('.tx-ppu-navigation').show()

        ppuAdd1()

        ppuScrollTop()
        ppuContainer.find('.tx-ppu-gradient').addClass('tx-ppu-active')
        ppuContainer.find('.tx-ppu-slider').slick('slickNext')
        $('.tx-ppu-navigation').addClass('tx-ppu-visible')
        window.setTimeout(function () {
            $('.tx-ppu-navigation').addClass('tx-ppu-active')
            ppuUpdateProgress()
        }, 1500)
    }
    function ppuBack() {
        if (ppuContainer.find('.slick-slide.slick-active .tx-ppu-skip-message').length) {
            ppuData.maxSteps = ppuData.maxStepsBeforeSkip
        }

        ppuData.step > 0 && ppuData.step--
        ppuSetStep(ppuData.step)
    }
    function ppuShowInfo() {
        $('#tx-ppu-info .tx-ppu-info-text').html(ppuContainer.find('.tx-ppu-slider .slick-slide[data-slick-index="' + ppuData.step + '"] .tx-ppu-slide').attr('data-info'))
    }
    function ppuSkip() {
        ppuAdd7b()

        ppuData.maxStepsBeforeSkip = ppuData.maxSteps
        ppuData.maxSteps = ppuData.step + 2

        ppuData.step++
        ppuSetStep(ppuData.step)
    }

    // Gebäude
    function ppuAdd1() {
        var slide = ppuTemplate('slideSelection')

        $.each(ppuSlides[2].options, function () {
            var selectionBox = ppuTemplate('selectionBoxImage')
            selectionBox.find('.tx-ppu-image-16_9').css('background-image', 'url(' + this.img + ')')
            selectionBox.find('h3').attr('data-match-height', 'tx-ppu-step-2-option').html(this.label)
            selectionBox.find('[data-ppu-action]').attr('data-ppu-action', ppuSlides[2].action).attr('data-ppu-value', this.id)
            slide.find('.tx-ppu-selection').append(selectionBox.html())
        })

        /*$.each(ppuSlides[1].options, function () {
            var selectionBox = ppuTemplate('selectionBoxImage')
            selectionBox.find('.tx-ppu-image-16_9').css('background-image', 'url(' + this.img + ')')
            selectionBox.find('h3').attr('data-match-height', 'tx-ppu-step-1-option').html(this.label)
            selectionBox.find('[data-ppu-action]').attr('data-ppu-action', ppuSlides[1].action).attr('data-ppu-value', this.id)
            slide.find('.tx-ppu-selection').append(selectionBox.html())
        })*/

        $($(ppuTemplate('additionSkip')).html()).insertAfter(slide.find('.tx-ppu-disabled-area'))

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
        $('[data-match-height]').matchHeight()
    }
    // Tätigkeit
    function ppuAdd3() {
        var slide = ppuTemplate('slideSelectionList')
        slide.find('.tx-ppu-title h2').html(ppuSlides[2].options[ppuData.selection[2]].title)
        slide.find('.tx-ppu-title h3').html(ppuSlides[2].options[ppuData.selection[2]].subline)
        slide.find('.tx-ppu-slide').attr('data-info', ppuSlides[2].options[ppuData.selection[2]].info)

        if (ppuSlides[2].options[ppuData.selection[2]].action == 'select3b') {
            // accordion view
            $.each(ppuSlides[2].options[ppuData.selection[2]].options, function () {
                var category = this

                var accordionContainer = ppuTemplate('selectionAccordionItem')
                accordionContainer.find('h4').html(category.label)

                // list in accordion
                $.each(category.options, function () {
                    var selectionBox = ppuTemplate('selectionListitem')
                    selectionBox.find('h5').html(this.label)
                    selectionBox.find('[data-ppu-action]').attr('data-ppu-action', ppuSlides[2].options[ppuData.selection[2]].action).attr('data-ppu-value', category.id + ',' + this.id)

                    if (typeof this.lux !== 'undefined') {
                        var luxInfo = ppuTemplate('additionLux')
                        luxInfo.find('.button div:first-child').text(this.lux + ' lux')
                        $(luxInfo.html()).insertAfter(selectionBox.find('h5'))
                    }

                    accordionContainer.find('.accordion__panel').append(selectionBox.html())
                })

                slide.find('.tx-ppu-selection-list').addClass('accordion').append(accordionContainer.html())
            })
        } else {
            // list view
            $.each(ppuSlides[2].options[ppuData.selection[2]].options, function () {
                var selectionBox = ppuTemplate('selectionListitem')
                selectionBox.find('h5').html(this.label)
                selectionBox.find('[data-ppu-action]').attr('data-ppu-action', ppuSlides[2].options[ppuData.selection[2]].action).attr('data-ppu-value', this.id)

                if (typeof this.lux !== 'undefined') {
                    var luxInfo = ppuTemplate('additionLux')
                    luxInfo.find('.button div:first-child').text(this.lux + ' lux')
                    $(luxInfo.html()).insertAfter(selectionBox.find('h5'))
                }

                slide.find('.tx-ppu-selection-list').append(selectionBox.html())
            })
        }

        $($(ppuTemplate('additionSkip')).html()).insertAfter(slide.find('.tx-ppu-containerbox'))

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
    }
    // Raumdaten
    function ppuAdd5() {
        var slide = ppuTemplate('slideRoom')

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
        $('[data-match-height]').matchHeight()

        ppuInitParsley()
    }
    // Nachricht bei Skip
    function ppuAdd7b() {
        var slide = ppuTemplate('slideSkipMessage')

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())

        ppuInitParsley()
    }
    // Kontaktdaten/Partner
    function ppuAdd8(partner) {
        var slide

        if (partner) {
            slide = ppuTemplate('slidePartner')
        } else {
            slide = ppuTemplate('slideContact')
        }

        if (ppuContainer.find('.slick-slide .tx-ppu-skip-message').length) {
            slide.find('.contact-message').parent().remove()
        }

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
        ppuContainer.find('.selectpicker-tmpl').removeClass('selectpicker-tmpl').addClass('selectpicker').selectpicker()

        ppuInitParsley()

        // badge
        if (!partner) {
            ppuContainer.find('.tx-ppu-saving-container').css('display', 'none')
        }

        if (ppuData.selection[1] != 1) {
            return;
        }

        if (partner) {
            if (!ppuContainer.find('.tx-ppu-customer-form').length) {
                return;
            }

            ppuContainer.find('.tx-ppu-contact-form .tx-ppu-saving-container').html(ppuContainer.find('.tx-ppu-customer-form .tx-ppu-saving-container').html()).show()
            $(window).trigger('resize')
        } else {
            $.post(ppuUrl, { tx_ytppu_ppu: ppuData }, function (data) {
                if (!data.annualSaving) {
                    return;
                }

                if (ppuLang == 'uk') {
                    if (data.annualSaving == ' ' || data.annualSaving <= 10000) {
                        var annualSaving = ppuSlides[6].upTo + ' £10,000'
                    } else if (data.annualSaving <= 30000) {
                        var annualSaving = ppuSlides[6].upTo + ' £30,000'
                    } else if (data.annualSaving <= 50000) {
                        var annualSaving = ppuSlides[6].upTo + ' £50,000'
                    } else if (data.annualSaving > 50000) {
                        var annualSaving = ppuSlides[6].moreThan + ' £50,000'
                    }
                } else {
                    if (data.annualSaving == ' ' || data.annualSaving <= 10000) {
                        var annualSaving = ppuSlides[6].upTo + ' 10.000 €'
                    } else if (data.annualSaving <= 30000) {
                        var annualSaving = ppuSlides[6].upTo + ' 30.000 €'
                    } else if (data.annualSaving <= 50000) {
                        var annualSaving = ppuSlides[6].upTo + ' 50.000 €'
                    } else if (data.annualSaving > 50000) {
                        var annualSaving = ppuSlides[6].moreThan + ' 50.000 €'
                    }
                }

                ppuContainer.find('.tx-ppu-saving-container .tx-ppu-amount').html(annualSaving)

                setTimeout(function () {
                    ppuContainer.find('.tx-ppu-saving-container').slideDown(500, function () {
                        $(window).trigger('resize')
                        setTimeout(function () {
                            $(window).trigger('resize')
                            ppuContainer.find('.tx-ppu-saving-container').addClass('tx-ppu-shine')
                        }, 200)
                    })
                }, 800)
            }, 'json')
        }
    }
    // Kundendaten
    function ppuAdd9() {
        var slide = ppuTemplate('slideCustomer')

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
        ppuContainer.find('.selectpicker-tmpl').removeClass('selectpicker-tmpl').addClass('selectpicker').selectpicker()

        ppuInitParsley()

        ppuContainer.find('.tx-ppu-saving-container').css('display', 'none')

        if (ppuData.selection[1] != 1) {
            return;
        }
        
        $.post(ppuUrl, { tx_ytppu_ppu: ppuData }, function (data) {
            if (!data.annualSaving) {
                return;
            }

            if (ppuLang == 'uk') {
                if (data.annualSaving == ' ' || data.annualSaving <= 10000) {
                    var annualSaving = ppuSlides[6].upTo + ' £10,000'
                } else if (data.annualSaving <= 30000) {
                    var annualSaving = ppuSlides[6].upTo + ' £30,000'
                } else if (data.annualSaving <= 50000) {
                    var annualSaving = ppuSlides[6].upTo + ' £50,000'
                } else if (data.annualSaving > 50000) {
                    var annualSaving = ppuSlides[6].moreThan + ' £50,000'
                }
            } else {
                if (data.annualSaving == ' ' || data.annualSaving <= 10000) {
                    var annualSaving = ppuSlides[6].upTo + ' 10.000 €'
                } else if (data.annualSaving <= 30000) {
                    var annualSaving = ppuSlides[6].upTo + ' 30.000 €'
                } else if (data.annualSaving <= 50000) {
                    var annualSaving = ppuSlides[6].upTo + ' 50.000 €'
                } else if (data.annualSaving > 50000) {
                    var annualSaving = ppuSlides[6].moreThan + ' 50.000 €'
                }
            }

            ppuContainer.find('.tx-ppu-saving-container .tx-ppu-amount').html(annualSaving)

            setTimeout(function () {
                ppuContainer.find('.tx-ppu-saving-container').slideDown(500, function () {
                    $(window).trigger('resize')
                    setTimeout(function () {
                        $(window).trigger('resize')
                        ppuContainer.find('.tx-ppu-saving-container').addClass('tx-ppu-shine')
                    }, 200)
                })
            }, 800)
        }, 'json')
    }
    // Ergebnis
    function ppuAddFinish() {
        var slide = ppuTemplate('slideFinish')

        if (!ppuData.selection[1]) {
            ppuData.selection[1] = 2;
        }

        $.each(ppuSlides[1].options[ppuData.selection[1]].finishOptions, function () {
            var selectionBox = ppuTemplate('selectionBoxLink')
            selectionBox.find('.tx-ppu-image-16_9').css('background-image', 'url(' + this.img + ')')
            selectionBox.find('h3').attr('data-match-height', 'tx-ppu-step-9-option').html(this.label)
            selectionBox.find('a').attr('href', this.url)
            slide.find('.tx-ppu-selection').append(selectionBox.html())
        })

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
        $('[data-match-height]').matchHeight()
    }
    // Fehler
    function ppuAddError() {
        var slide = ppuTemplate('slideError')

        ppuContainer.find('.tx-ppu-slider').slick('slickAdd', slide.html())
    }

    // Zweck
    function ppuHandle1(value) {
        ppuData.selection[1] = parseInt(value)

        dataLayer.push({
            'event': ppuEventKey,
            'step': '1',
            'option': ppuHtmldecode(ppuSlides[1].options[ppuData.selection[1]].label)
        })

        ppuContainer.find('[data-ppu-action="select1"]').removeClass('button--cta')
        ppuContainer.find('[data-ppu-action="select1"][data-ppu-value="' + value + '"]').addClass('button--cta')

        ppuContainer.find('.tx-ppu-disabled-area').addClass('tx-ppu-enabled')
    }
    // Gebäudeart
    function ppuHandle2(value) {
        ppuData.selection[2] = parseInt(value)

        dataLayer.push({
            'event': ppuEventKey,
            'step': '2',
            'option': ppuHtmldecode(ppuSlides[2].options[ppuData.selection[2]].label)
        })

        if (ppuData.selection[2] == 2) {
            ppuData.selection[3] = 10
            ppuData.maxSteps = 3
            ppuAdd5()
        } else {
            ppuData.maxSteps = 4
            ppuAdd3()
        }

        ppuData.step++
        ppuSetStep(ppuData.step)
    }
    // Tätigkeit
    function ppuHandle3(value) {
        ppuData.selection[3] = parseInt(value)

        if (ppuData.selection[2] == 3)
            ppuAdd3b()
        else {
            dataLayer.push({
                'event': ppuEventKey,
                'step': '3',
                'option': ppuHtmldecode(ppuSlides[2].options[ppuData.selection[2]].options[ppuData.selection[3]].label)
            })

            ppuAdd5()
        }

        ppuData.step++
        ppuSetStep(ppuData.step)
    }
    // Tätigkeit bei Accordion
    function ppuHandle3b(value) {
        var values = value.split(',')

        ppuData.selection[3] = parseInt(values[0])
        ppuData.selection[4] = parseInt(values[1])

        dataLayer.push({
            'event': ppuEventKey,
            'step': '3',
            'option': ppuHtmldecode(ppuSlides[2].options[ppuData.selection[2]].options[ppuData.selection[3]].options[ppuData.selection[4]].label)
        })

        ppuAdd5()

        ppuData.step++
        ppuSetStep(ppuData.step)
    }
    // Raumdaten
    function ppuHandle5() {
        ppuContainer.find('.slick-slide.slick-active .form').submit()

        if (!ppuContainer.find('.room-daily-usage').parsley().isValid()
            || !ppuContainer.find('.room-days-per-month').parsley().isValid()
            || !ppuContainer.find('.room-size-y').parsley().isValid()
            || !ppuContainer.find('.room-size-x').parsley().isValid()
            || !ppuContainer.find('.room-size-z').parsley().isValid()) {
            return;
        }

        ppuData.input.room.dailyUsage = ppuContainer.find('.room-daily-usage').val()
        ppuData.input.room.daysPerMonth = ppuContainer.find('.room-days-per-month').val()
        ppuData.input.room.sizeY = ppuContainer.find('.room-size-y').val()
        ppuData.input.room.sizeX = ppuContainer.find('.room-size-x').val()
        ppuData.input.room.sizeZ = ppuContainer.find('.room-size-z').val()

        dataLayer.push({
            'event': ppuEventKey,
            'step': '5'
        })

        if (ppuData.forCustomer == 1) {
            ppuAdd9()
        } else {
            ppuAdd8(false)
        }

        ppuData.step++
        ppuSetStep(ppuData.step)
    }
    // Nachricht bei Skip
    function ppuHandle7b() {
        ppuContainer.find('.slick-slide.slick-active .form').submit()

        if (!ppuContainer.find('.contact-message').parsley().isValid()) {
            return;
        }

        ppuData.input.contact.message = ppuContainer.find('.contact-message').val()

        ppuAdd8()

        ppuData.step++
        ppuSetStep(ppuData.step)
    }
    // Kontaktdaten/Partner
    function ppuHandle8() {
        ppuContainer.find('.slick-slide.slick-active .form').submit()

        if (!ppuContainer.find('.contact-salutation.selectpicker').parsley().isValid()
            || !ppuContainer.find('.contact-lastname').parsley().isValid()
            || !ppuContainer.find('.contact-firstname').parsley().isValid()
            || !ppuContainer.find('.contact-company').parsley().isValid()
            || !ppuContainer.find('.contact-address').parsley().isValid()
            || !ppuContainer.find('.contact-postal').parsley().isValid()
            || !ppuContainer.find('.contact-city').parsley().isValid()
            || !ppuContainer.find('.contact-email').parsley().isValid()
            || !ppuContainer.find('.contact-phone').parsley().isValid()
            || !ppuContainer.find('.contact-message').parsley().isValid()) {
            return;
        }

        ppuContainer.find('.tx-ppu-contact-form').addClass('tx-ppu-loading').find('[data-ppu-action="submit8"]').prop('disabled', true)
        $('.tx-ppu-navigation').removeClass('tx-ppu-visible tx-ppu-active')

        ppuData.input.contact.salutation = ppuContainer.find('.contact-salutation.selectpicker').val()
        ppuData.input.contact.lastname = ppuContainer.find('.contact-lastname').val()
        ppuData.input.contact.firstname = ppuContainer.find('.contact-firstname').val()
        ppuData.input.contact.company = ppuContainer.find('.contact-company').val()
        ppuData.input.contact.address = ppuContainer.find('.contact-address').val()
        ppuData.input.contact.postal = ppuContainer.find('.contact-postal').val()
        ppuData.input.contact.city = ppuContainer.find('.contact-city').val()
        ppuData.input.contact.country = ppuContainer.find('.contact-country.selectpicker').val()
        ppuData.input.contact.email = ppuContainer.find('.contact-email').val()
        ppuData.input.contact.phone = ppuContainer.find('.contact-phone').val()
        ppuData.input.contact.message = ppuContainer.find('.contact-message').val()

        $.post(ppuUrlSubmit, { tx_ytppu_ppu: ppuData }, function (data) {
            if (data.status == 'OK') {
                dataLayer.push({
                    'event': ppuEventKey,
                    'step': '8'
                })

                ppuAddFinish()
            } else {
                ppuAddError()
            }

            ppuData.step++
            ppuSetStep(ppuData.step)
        }, 'json')
    }
    // Kundendaten
    function ppuHandle9() {
        ppuContainer.find('.slick-slide.slick-active .form').submit()

        if (!ppuContainer.find('.customer-salutation.selectpicker').parsley().isValid()
            || !ppuContainer.find('.customer-lastname').parsley().isValid()
            || !ppuContainer.find('.customer-firstname').parsley().isValid()
            || !ppuContainer.find('.customer-company').parsley().isValid()
            || !ppuContainer.find('.customer-address').parsley().isValid()
            || !ppuContainer.find('.customer-postal').parsley().isValid()
            || !ppuContainer.find('.customer-city').parsley().isValid()
            || !ppuContainer.find('.customer-email').parsley().isValid()
            || !ppuContainer.find('.customer-phone').parsley().isValid()) {
            return;
        }

        ppuData.input.customer.salutation = ppuContainer.find('.customer-salutation.selectpicker').val()
        ppuData.input.customer.lastname = ppuContainer.find('.customer-lastname').val()
        ppuData.input.customer.firstname = ppuContainer.find('.customer-firstname').val()
        ppuData.input.customer.company = ppuContainer.find('.customer-company').val()
        ppuData.input.customer.address = ppuContainer.find('.customer-address').val()
        ppuData.input.customer.postal = ppuContainer.find('.customer-postal').val()
        ppuData.input.customer.city = ppuContainer.find('.customer-city').val()
        ppuData.input.customer.country = ppuContainer.find('.customer-country.selectpicker').val()
        ppuData.input.customer.email = ppuContainer.find('.customer-email').val()
        ppuData.input.customer.phone = ppuContainer.find('.customer-phone').val()

        dataLayer.push({
            'event': ppuEventKey,
            'step': '9'
        })

        ppuAdd8(true)

        ppuData.step++
        ppuSetStep(ppuData.step)
    }

    $('#tx-ppu-container').on('click', '[data-ppu-action]', function (e) {
        e.preventDefault()
        var ppuAction = $(this).attr('data-ppu-action')
        var ppuValue = $(this).attr('data-ppu-value')

        if (ppuAction == 'alert') {
            alert(ppuValue)
        } else if (ppuAction == 'start') {
            ppuStart(ppuValue)
        } else if (ppuAction == 'back') {
            ppuBack()
        } else if (ppuAction == 'info') {
            ppuShowInfo()
        } else if (ppuAction == 'skip') {
            ppuSkip()
        } else if (ppuAction == 'select1') {
            ppuHandle1(ppuValue)
        } else if (ppuAction == 'select2') {
            ppuHandle2(ppuValue)
        } else if (ppuAction == 'select3') {
            ppuHandle3(ppuValue)
        } else if (ppuAction == 'select3b') {
            ppuHandle3b(ppuValue)
        } else if (ppuAction == 'continue5') {
            ppuHandle5()
        } else if (ppuAction == 'continue7b') {
            ppuHandle7b()
        } else if (ppuAction == 'submit8') {
            ppuHandle8()
        } else if (ppuAction == 'submit9') {
            ppuHandle9()
        }
    })

    ppuContainer.find('.tx-ppu-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        mobileFirst: true,
        adaptiveHeight: true,
        speed: 1000,
        draggable: false,
        swipe: false,
        accessibility: false,
        waitForAnimate: false
    })

    ppuContainer.on('submit', 'form', function (e) {
        e.preventDefault()
    })

    $(window).on('resize orientationchange accordionChanged', function () {
        ppuContainer.find('.tx-ppu-slider').slick('setPosition')
    })
})
